import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgModalBackgroundPattern = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 216,
	height: 216,
	viewBox: "0 0 216 216",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("mask", {
			id: "mask0_8971_21301",
			style: { maskType: "alpha" },
			maskUnits: "userSpaceOnUse",
			x: -120,
			y: -120,
			width: 336,
			height: 336,
			children: /* @__PURE__ */ _jsx("rect", {
				width: 336,
				height: 336,
				transform: "translate(-120 -120)",
				fill: "url(#paint0_radial_8971_21301)"
			})
		}),
		/* @__PURE__ */ _jsxs("g", {
			mask: "url(#mask0_8971_21301)",
			children: [
				/* @__PURE__ */ _jsx("circle", {
					cx: 48,
					cy: 48,
					r: 47.5,
					stroke: "#CCCCCC"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 48,
					cy: 48,
					r: 47.5,
					stroke: "#CCCCCC"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 48,
					cy: 48,
					r: 71.5,
					stroke: "#CCCCCC"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 48,
					cy: 48,
					r: 95.5,
					stroke: "#CCCCCC"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 48,
					cy: 48,
					r: 119.5,
					stroke: "#CCCCCC"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 48,
					cy: 48,
					r: 143.5,
					stroke: "#CCCCCC"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 48,
					cy: 48,
					r: 167.5,
					stroke: "#CCCCCC"
				})
			]
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsxs("radialGradient", {
			id: "paint0_radial_8971_21301",
			cx: 0,
			cy: 0,
			r: 1,
			gradientUnits: "userSpaceOnUse",
			gradientTransform: "translate(168 168) rotate(90) scale(168 168)",
			children: [/* @__PURE__ */ _jsx("stop", {}), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopOpacity: 0
			})]
		}) })
	]
});
export default SvgModalBackgroundPattern;
